import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

interface AnalyticsRetention {
  retention_days: number;
  unlimited: boolean;
  tier_name: string;
}

export const useAnalyticsRetention = () => {
  const { data, isLoading, error } = useQuery<AnalyticsRetention>({
    queryKey: ['analyticsRetention'],
    queryFn: async () => {
      const response = await api.get('/social/limits/analytics-retention');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return {
    retentionDays: data?.retention_days ?? 30,
    isUnlimited: data?.unlimited ?? false,
    tierName: data?.tier_name ?? 'free',
    isLoading,
    error,
  };
};
